import { render, staticRenderFns } from "./grupAH.vue?vue&type=template&id=33e5c29a&scoped=true&"
import script from "./grupAH.vue?vue&type=script&lang=js&"
export * from "./grupAH.vue?vue&type=script&lang=js&"
import style0 from "./grupAH.vue?vue&type=style&index=0&id=33e5c29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5c29a",
  null
  
)

export default component.exports